import { createAction, props } from '@ngrx/store';
import { WorkflowSettings } from './workflow-settings.model';


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record workflow settings'
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record workflow settings success', 
    props<{ singleData: WorkflowSettings }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record workflow settings failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record workflow settings',
    props<{ updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record workflow settings success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record workflow settings failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state workflow settings',
);